<div class="d-md-flex d-sm-block">
  <form class="d-flex flex-grow-1 justify-content-between" [formGroup]="signalFilterForm" (ngSubmit)="onSignalListFilterFormSubmit($event)">
    <div class="d-md-flex d-sm-block flex-grow-1 gap-3">
      <input formControlName="startDate"
        type="date"
        class="form-control"
        placeholder="Дата/час от:"
      />
      <input formControlName="endDate"
        type="date"
        class="form-control"
        placeholder="Дата/час до:"
      />
      <select formControlName="signalStatus" class="form-select">
        <option [ngValue]="null" disabled>
          Изберете статус на сигнал
        </option>
        <ng-container *ngFor="let item of signalStatusesList">
          <ng-container *ngIf="item.isActive">
            <option [ngValue]="item.id">{{ item.title }}</option>
          </ng-container>
        </ng-container>
      </select>
    </div>
    <div class="d-md-flex flex-grow-1 justify-content-end gap-3">
      <button type="submit" name="signalListFilterSearchBtn" class="btn btn-outline-primary btn-sm" >
        Търси
      </button>
    </div>
  </form>
</div>
